/**
 * SQL结果区的默认状态, 操作指引
 */
import { useAigcIntl } from '@/pages/aigc/utils/utils';
import React from 'react';

export default function Operating() {
  const { formatMessage: multiFormatMessage } = useAigcIntl('text2sql');
  const configList = [
    {
      headline: 'operational_one_title',
      description: [
        {
          text: 'operational_one_content_first',
        },
      ],
    },
    {
      headline: 'operational_two_title',
      description: [
        {
          text: 'operational_two_content_first',
        },
        {
          text: 'operational_two_content_second',
        },
      ],
    },
    {
      headline: 'operational_three_title',
      description: [
        {
          text: 'operational_three_content_first',
        },
        {
          text: 'operational_three_content_second',
        },
        {
          text: 'operational_three_content_last_message',
        },
      ],
    },
  ];

  return (
    <div className="guide_operation">
      {configList?.map((item, key) => (
        <div className="guide_operation-flex" key={key}>
          <div className="flex-left">
            <div className="flex-left-num">{key + 1}</div>
            <div className="flex-left-text">
              {multiFormatMessage(item.headline)} <br />
            </div>
          </div>
          <div className="flex-right">
            <div className="flex-right-text">
              {item.description.map((task) => (
                <>
                  {multiFormatMessage(task?.text)}
                  <br />
                </>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
